<template>
  <button
    class="back-button"
    :class="{ 'back-button--active': isActive }"
    @click.prevent="$emit('click')"
    @submit.prevent="$emit('click')"
  >
    <slot>{{ text }}</slot>
  </button>
</template>

<script>
export default {
  components: {},
  props: {
    text: String,
    isActive: Boolean,
  },
  emits: ['click'],
  data() {
    return {};
  },
  methods: {},
  computed: {},
  watch: {},
  // created: function() {}
};
</script>

<style scoped>
.back-button {
  /*background: linear-gradient(-10deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.2));*/
  background-color: black;
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-radius: 11px;
  color: white;
  font-size: 24px;
  padding: 0.75rem 2rem;
  /* height: 80px; */
  min-width: 120px;
  /* width: 30%; */
}
.back-button--active {
  box-shadow: 0 0 6px 4px rgba(255, 255, 255, 0.5);
  border-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/BackButton.vue